// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// if value is an empty string or is NaN it returns null
// otherwise it returns the value cast as a number.
// this is useful because redux-form prefers to work with string values
// and the value selected may be '' which should be null for API.
// see how <SelectDynamic /> uses prop emptyOptionLabel for an example of this.
// NOTE - these checks (in place of regex) allow us to support scientific notation in the value
// NOTE - first isNaN check handles false, '', null and undefined
// NOTE - second one handles strings like '1.3e' which parseFloat returns as 1.3
const castToFloat = v => !isNaN(parseFloat(v)) && !isNaN(+v) ? +v : null

export default castToFloat
